export const colors = {
  lightOrange: "#FEE6D6",
  darkBlue: "#1F263C",
  midOrange: "#F5A872",
  darkOrange: "#FF7C60",
  purple: "#C49ABE",
  blue: "rgba(0,129,186, 0.6)",
  midBlue: "#e3e1f2",
  white: "#e3e1f2",
};
